import { ChangeEvent } from "react"
import { useLanguageTool } from "../hooks/useLanguageTool"
import { Variants } from "../config/types"

export const VariantSelector = () => {

    const { variant, setVariant } = useLanguageTool()

    function handleChange(e : ChangeEvent<HTMLInputElement>) {
        setVariant(e.target.value as Variants)
    }
    
    return (<div className="formes">
    <p>Formes verbals:</p>
    <label className="radio-inline">
        <input type="radio" name="variant" id="variant_general" value="variant_general"
            checked={variant === Variants.General} onChange={handleChange}
            /> centrals
    </label>
    <label className="radio-inline">
        <input type="radio" name="variant" id="variant_valencia" value="variant_valencia"
            checked={variant === Variants.Valencianes} onChange={handleChange}
            /> valencianes
    </label>
    <label className="radio-inline">
        <input type="radio" name="variant" id="variant_balear" value="variant_balear"
            checked={variant === Variants.Balears} onChange={handleChange}
            /> balears
    </label>
</div>)
}